import angular from 'angular';
import csmUITools from '../../util/tools/tools';

export default angular
  .module('csm.ui.stateSelector', [csmUITools])

  /*******************************************************************************
   * Directive: stateSelector
   *
   * This provides a dropdown selection of states. This needs to be used with
   * a select element and provides the ability to display either the symbol or
   * the state name indicated by the <b>use-name</b> attribute.
   *******************************************************************************/
  /* @ngInject */
  .directive('stateSelector', function ($compile, Tools) {
    /** States List. */
    var mStates = [
      { symbol: 'AK', name: 'Alaska' },
      { symbol: 'AL', name: 'Alabama' },
      { symbol: 'AR', name: 'Arkansas' },
      { symbol: 'AZ', name: 'Arizona' },
      { symbol: 'CA', name: 'California' },
      { symbol: 'CO', name: 'Colorado' },
      { symbol: 'CT', name: 'Connecticut' },
      { symbol: 'DC', name: 'District of Columbia' },
      { symbol: 'DE', name: 'Delaware' },
      { symbol: 'FL', name: 'Florida' },
      { symbol: 'GA', name: 'Georgia' },
      { symbol: 'HI', name: 'Hawaii' },
      { symbol: 'IA', name: 'Iowa' },
      { symbol: 'ID', name: 'Idaho' },
      { symbol: 'IL', name: 'Illinois' },
      { symbol: 'IN', name: 'Indiana' },
      { symbol: 'KS', name: 'Kansas' },
      { symbol: 'KY', name: 'Kentucky' },
      { symbol: 'LA', name: 'Louisiana' },
      { symbol: 'MA', name: 'Massachusetts' },
      { symbol: 'MD', name: 'Maryland' },
      { symbol: 'ME', name: 'Maine' },
      { symbol: 'MI', name: 'Michigan' },
      { symbol: 'MN', name: 'Minnesota' },
      { symbol: 'MO', name: 'Missouri' },
      { symbol: 'MS', name: 'Mississippi' },
      { symbol: 'MT', name: 'Montana' },
      { symbol: 'NC', name: 'North Carolina' },
      { symbol: 'ND', name: 'North Dakota' },
      { symbol: 'NE', name: 'Nebraska' },
      { symbol: 'NH', name: 'New Hampshire' },
      { symbol: 'NJ', name: 'New Jersey' },
      { symbol: 'NM', name: 'New Mexico' },
      { symbol: 'NV', name: 'Nevada' },
      { symbol: 'NY', name: 'New York' },
      { symbol: 'OH', name: 'Ohio' },
      { symbol: 'OK', name: 'Oklahoma' },
      { symbol: 'OR', name: 'Oregon' },
      { symbol: 'PA', name: 'Pennsylvania' },
      { symbol: 'RI', name: 'Rhode Island' },
      { symbol: 'SC', name: 'South Carolina' },
      { symbol: 'SD', name: 'South Dakota' },
      { symbol: 'TN', name: 'Tennessee' },
      { symbol: 'TX', name: 'Texas' },
      { symbol: 'UT', name: 'Utah' },
      { symbol: 'VA', name: 'Virginia' },
      { symbol: 'VT', name: 'Vermont' },
      { symbol: 'WA', name: 'Washington' },
      { symbol: 'WI', name: 'Wisconsin' },
      { symbol: 'WV', name: 'West Virginia' },
      { symbol: 'WY', name: 'Wyoming' }
    ];

    return {
      restrict: 'A',
      require: ['select'],
      scope: { ngModel: '=' },
      link: function (scope, element) {
        /*----------------------*/
        /* Initialize the scope */
        /*----------------------*/
        scope.states = mStates;

        /*-----------------------------------------------------------------*/
        /* Build state option elements with a string. This will not create */
        /* child scopes for each element which will enhance performance.   */
        /*-----------------------------------------------------------------*/
        var options = scope.states.map(function (s, i) {
          var stateStr = 'states[' + i + ']';
          return (
            '<option value="{{' +
            stateStr +
            '.symbol}}">{{useName ? ' +
            stateStr +
            '.name : ' +
            stateStr +
            '.symbol}}</option>'
          );
        });
        var angOptions = angular.element(options.join(''));
        element.append(angOptions);

        /*--------------------------------------------------*/
        /* The options are compiled after being added as    */
        /* angular has select and option directives which   */
        /* need the elements added to the DOM when linking. */
        /*--------------------------------------------------*/
        $compile(angOptions)(scope);

        /*************************************************************************
         * setUseName */
        /**
         * Updates the useName flag on the scope based off provided value.
         *
         * @param value  Attribute value for 'use-name' to check
         *************************************************************************/
        var setUseName = function (value) {
          scope.useName =
            value != undefined && (Tools.isEmpty(value) || scope.$eval(value));
        };

        /*--------------------------*/
        /* Watch for useName change */
        /*--------------------------*/
        scope.$watch(function () {
          return element.attr('use-name');
        }, setUseName);
      }
    };
  }).name;
